export function isValidSelectCountry(countryId) {
  return countryId !== "" || "Country is required"
}
export const rules = [isValidSelectCountry]
